import * as type from './actionType'

export interface SessionsCount {
  label: string
  session_count: number
  user_count: number
}

interface QuizSubmissionsInterface {
  quizSubmissions: { date: string; submission_count: number }[]
}

export interface CommentsInterface {
  _id: string
  organisation_id: string
  agent_id: string
  author_id: string
  author_email: string
  rating: number
  comment: string
  updated_at: string
  created_at: string
}

interface DashboardreducerState {
  loading: boolean
  error: boolean
  sessions_count: number
  activeUsersSessions: SessionsCount[]
  conversation_turn_average: number
  conversation_turn_highest: number
  top_questions: any[]
  quizSubmissions: QuizSubmissionsInterface[]
  comments: CommentsInterface[]
  ratingSummary: {
    rows: any[]
    summary: {
      rating_average: number
      rating_count: number
    }
  }
}

const initialState: DashboardreducerState = {
  loading: null,
  error: null,
  sessions_count: null,
  conversation_turn_average: null,
  conversation_turn_highest: null,
  quizSubmissions: [],
  top_questions: [],
  activeUsersSessions: [],
  comments: [],
  ratingSummary: {
    rows: [],
    summary: {
      rating_average: 0,
      rating_count: 0,
    },
  },
}

const Dashboardreducer = (state = initialState, action: any) => {
  switch (action.type) {
    case type.FETCH_DASHBOARD_SESSION_COUNT:
      return {
        ...state,
        ...action.payload,
      }
    case type.FETCH_RATINGS_SUMMARY:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return {
        ...state,
      }
  }
}

export default Dashboardreducer
